import { email, required } from 'vuelidate/lib/validators'
import Validation from '@/providers/Validation'
import Vue from 'vue'

function formatAddress (rentalCompany) {
    return (rentalCompany.address_1 ? rentalCompany.address_1 : '') +
        (rentalCompany.address_2 ? ', ' + rentalCompany.address_2 : '') +
        (rentalCompany.city ? '; ' + rentalCompany.city : '') +
        (rentalCompany.state ? ', ' + rentalCompany.state : '') +
        (rentalCompany.zip ? ' ' + rentalCompany.zip : '')
}

//NB: Duplicate any changes here to the rental-company fields in Rental.js
export default {
    formatAddress,
    fields: {
        name: {
            label: 'Rental Company Name',
            type: 'text',
            validations: { required },
        },
        address_1: {
            label: 'Address 1',
            type: 'text',
            validations: { required },
        },
        address_2: {
            label: 'Address 2',
            type: 'text',
        },
        city: {
            label: 'City',
            type: 'text',
            validations: { required },
        },
        state: {
            label: 'State',
            type: 'state',
            validations: { required },
        },
        zip: {
            label: 'Zip',
            type: 'text',
            validations: { required },
        },
        phone: {
            label: 'Phone',
            type: 'text',
            onChange (model) {
                Vue.nextTick(() => {
                    model['phone'] = Validation.formatPhoneNumber(model['phone'])
                })
            },
            validations: {
                required,
                phone: Validation.validatePhoneNumber(),
            },
        },
        email: {
            label: 'Rental Contact Email',
            type: 'text',
            validations: { required, email },
        },
        status: {
            label: 'Status',
            type: 'select',
            options: [
                { value: 'APPROVED', text: 'Approved' },
                { value: 'UNAPPROVED', text: 'Unapproved' }
            ],
            validations: { required }
        }
    }
}